// eslint-disable-next-line import/prefer-default-export
export const muiAccordionComponent = {
  defaultProps: {
    slotProps: {
      heading: {
        component: 'div',
      },
    },
  },
  styleOverrides: {
    root: () => ({
      padding: '0',

      [`&.Mui-expanded`]: {
        margin: '0',
      },
    }),
  },
};
